import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URLS } from '../constants/constants';
import { HeaderType } from '../enums/enums';
import { SalesDataModel } from '../models/sales-dashboard.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class SalesDashboardService {
  constructor(private readonly http: HttpService) {}

  fetchSalesTrackerSummary(
    startDate?: string,
    endDate?: string
  ): Observable<SalesDataModel> {
    return this.http.get(
      `${URLS.salesTrackerSummary}?${
        startDate ? 'startDate=' + startDate : ''
      }${startDate && endDate ? '&' : ''}${
        endDate ? 'endDate=' + endDate : ''
      }`,
      {
        params: { headerType: HeaderType.ACCESS },
      }
    );
  }
  fetchSalesTrackerOwnerSummary(
    startDate?: string,
    endDate?: string
  ): Observable<SalesDataModel> {
    return this.http.get(
      `${URLS.salesTrackerOwnerSummary}?${
        startDate ? 'startDate=' + startDate : ''
      }${startDate && endDate ? '&' : ''}${
        endDate ? 'endDate=' + endDate : ''
      }`,
      {
        params: { headerType: HeaderType.ACCESS },
      }
    );
  }
}
